/**
 * User instructions for password creation 
 */
export enum PasswordCreationRulesText {
  USen = "Please use at least 12 characters.",
  JAjp = "12文字以上を使用してください。"
}